<template>
  <div class="home-page-1">
    <div class="box-title">数据总览</div>
    <div class="page1-content">
      <div class="page1-content-list">
        <div class="list-top">
          <el-image
            :src="require('@/assets/images/jryy.png')"
            class="top-image"
          ></el-image>
          <span class="list-txt">总线路数</span>
        </div>
        <div class="list-num">20</div>
      </div>
      <div class="page1-content-list">
        <div class="list-top">
          <el-image
            :src="require('@/assets/images/dshdd.png')"
            class="top-image"
          ></el-image>
          <span class="list-txt">总设备数</span>
        </div>
        <div class="list-num">122</div>
      </div>
      <div class="page1-content-list">
        <div class="list-top">
          <el-image
            :src="require('@/assets/images/dqydd.png')"
            class="top-image"
          ></el-image>
          <span class="list-txt">总任务数</span>
        </div>
        <div class="list-num">60</div>
      </div>
      <div class="page1-content-list">
        <div class="list-top">
          <el-image
            :src="require('@/assets/images/qyzdds.png')"
            class="top-image"
          ></el-image>
          <span class="list-txt">总订单数</span>
        </div>
        <div class="list-num">320</div>
      </div>
      <div class="page1-content-list">
        <div class="list-top">
          <el-image
            :src="require('@/assets/images/zdds.png')"
            class="top-image"
          ></el-image>
          <span class="list-txt">总配置数</span>
        </div>
        <div class="list-num">20</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAdminOrder } from "@/views/HomePage/api";

export default {
  name: "OrderOverview",
  components: {},
  data() {
    return {
      detail: {
        totalOrder: 2000,
      },
    };
  },
  mounted() {
    // this.getDetail();
  },
  methods: {
    getDetail() {
      getAdminOrder().then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home-page-1 {
  width: 100%;
  height: 1.74rem;
  background: url("~@/assets/images/home_bg1.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 0.08rem;
  margin-bottom: 0.16rem;
  padding: 0.16rem;
  box-sizing: border-box;
  .box-title {
    font-weight: 500;
    font-size: 0.16rem;
    color: #1f2329;
    padding-bottom: 0.16rem;
  }
  .page1-content {
    display: flex;
    .page1-content-list {
      width: 20%;
      margin-top: 0.1rem;
      padding-left: 0.2rem;
      .list-top {
        display: flex;
        align-items: center;
        .top-image {
          width: 0.16rem;
          height: 0.16rem;
        }
        .list-txt {
          font-weight: 400;
          font-size: 0.14rem;
          color: #69718c;
          padding-left: 0.04rem;
          line-height: 0.2rem;
        }
      }
      .list-num {
        font-weight: 500;
        font-size: 0.26rem;
        color: #212533;
        font-family: pm, serif;
        padding-top: 0.14rem;
        line-height: 0.34rem;
      }
    }
  }
}
</style>
